// extracted by mini-css-extract-plugin
export default {"emailButton":"Footer_emailButton__oUViV","subscribeButton":"Footer_subscribeButton__HMp7k"};